/**
 * The role the header shows for a user who holds several. The API returns a user's roles in storage order (no meaning),
 * so "the first one" made an administrator who also holds the vendor role read as a vendor. Most privileged first:
 * administration, then the operational roles, then the tenant/vendor ones.
 */
const ROLE_PRECEDENCE = [
  'SuperAdmin',
  'SystemAdmin',
  'FacilityManager',
  'AssetManager',
  'StoreInventoryManager',
  'MaintenanceTechnician',
  'VendorContractor',
  'CommercialTenant',
  'ResidentialTenant',
];

export function primaryRole(roles: readonly string[] | null | undefined): string | null {
  if (!roles?.length) return null;
  const rank = (role: string) => {
    const index = ROLE_PRECEDENCE.indexOf(role);
    return index === -1 ? ROLE_PRECEDENCE.length : index;
  };
  return [...roles].sort((a, b) => rank(a) - rank(b))[0];
}
